import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-periapical',
    templateUrl: './periapical.component.html',
    styleUrls: ['./periapical.component.scss'],
    standalone: false
})
export class PeriapicalComponent implements OnInit {

  title = 'datatables';
  dtOptions: DataTables.Settings = {};

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
      public idOrdenFisc :string = "";
  public selected: string = "";
  public pacienteSecuencia: string = "";
  public doctorSecuencia: string = "";
  public asesorSencuencia: string = "";
  private _usuario!: Usuario;
  public idSucursal!: string;
  public nombreSucursal: string = "";
  public perfil: string = '';
  public myTable: boolean = false;
  ordenes: any = [];
  public spinnerBoolean: boolean = false;
  public estadoFiltro: string = 'pendiente';
  public spinnerBooleanAsignarOrden: boolean = false;

  public fechaInicio = '';
  public fechaFin = '';
  public pagina;
  public busqueda;
  public limite;
  public txtOrdenFisica: string = "";

  constructor(private ordenesService: OrdenesService,
    private authService: AuthService,
    private toastr: ToastrService,
        private modalService: NgbModal,
    public router: Router) {
      this._usuario = authService.loginUsuario;
     }

  ngOnInit(): void {
    this.idSucursal = this._usuario.sucursal!;
    this.nombreSucursal = this._usuario.nombreSucursal!;
    this.perfil = this._usuario.perfil!;

    this.datatablePeriapical();
  }

  datatablePeriapical(){
    this.spinnerBoolean = true;
    let lastPage = 0;
    let lastSearchText = "";
    this.dtOptions = {
      language: LanguageApp.spanish_datatables,
      pagingType: 'full_numbers',
      pageLength: 10,
      displayStart: lastPage, // Last Selected Page
      search: { search: lastSearchText }, // Last Searched Text
      serverSide: true,
      // processing: true,
      responsive: true,
      ajax: (dataTablesParameters: any, callback) => {

        this.pagina = dataTablesParameters.start;
        this.busqueda = dataTablesParameters.search.value;
        this.limite = dataTablesParameters.length;

        this.ordenesService.dtPeriapical(
          this.estadoFiltro,
          this.idSucursal,
          this.fechaInicio,
          this.fechaFin,
          this.pagina,
          this.busqueda,
          this.limite
        ).subscribe(resp => {

          this.ordenes = resp.data;
          this.spinnerBoolean = false;
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });
        })
      }
    };
  }

  
  filtrarPeriapicalFechas(){
    this.reload();
  }

  reload() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload();
    });
  }
  
  /* -------------------------------------------------------------------------- */
  /*                               FACTURAR ORDEN                               */
  /* -------------------------------------------------------------------------- */
  subirImagenes(idOrden) {
    this.router.navigate(['/sistema/subir-imagenes-periapical', this.makeid(100) + idOrden + this.makeid(100)]);
  }

    /* -------------------------------------------------------------------------- */
  /*                           GENERAR ALEATORIO ROUTE                          */
  /* -------------------------------------------------------------------------- */
  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJ12345679KLMNOPQRST08765454UVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  modalSecuenciaFisica(basicModal: any) {
    this.modalService.open(basicModal);

  }

               

  modalCuponDescuento(basicModal: any) {
    this.modalService.open(basicModal);
    
  }

  modalEnvioExpress(basicModal: any) {
    this.modalService.open(basicModal);

  }

  subirOrdenFisica(){
    if(this.spinnerBooleanAsignarOrden) return;
      this.spinnerBooleanAsignarOrden = true;
       this.ordenesService.subirOrdenFisica(
        
        this.idOrdenFisc,
        this.txtOrdenFisica,
        localStorage.getItem('token'),
     
       
      ).subscribe((resp) => {
  
        this.spinnerBooleanAsignarOrden = false;
        if(resp == "ok"){
          this.toastr.success("Subida correctamente", 'Atención', {
            timeOut: 7000,
            closeButton: true,
            progressBar: true
          });
             this.modalService.dismissAll();
            location.reload();
        }else{

        

          this.toastr.success("Multimedia actualizada correctamente y subida a la nube C&M", 'Atención', {
            timeOut: 7000,
            closeButton: true,
            progressBar: true
          });
          this.router.navigateByUrl('sistema/inicio');
          
        }
     
  
      });
  }
    ordenFisica(event){

    const file =  event.target.files[0]
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
    

    this.txtOrdenFisica = reader.result as string;
    console.log(this.txtOrdenFisica);
      
    };        
  }


  cerrarModalEnvio() {

    this.modalService.dismissAll();
    location.reload();
  }

  /* -------------------------------------------------------------------------- */
  /*                       OBTENER SECUENCIA SELECCIONADA                       */
  /* -------------------------------------------------------------------------- */
  validarSecuenciaFisicaSF() {

    if (this.selected == "") {
      this.toastr.error("Por favor ingrese una secuencia.", 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });

      return;

    }
    this.spinnerBooleanAsignarOrden = true;
    this.ordenesService.buscarSecuenciaFisica(localStorage.getItem('token'), "secuencia-fisica", "NUM_SECORD", this.selected.toString().padStart(9, "0")).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));

      if (content.length >= 1) {

        if (content[0].CLI_SECORD != "" && content[0].CLI_SECORD != "null" && content[0].CLI_SECORD != null) {

          this.pacienteSecuencia = content[0].CLI_SECORD;
          this.doctorSecuencia = content[0].NOMDOC_SECORD;
          this.asesorSencuencia = content[0].ASEASIG_BLOCK;
          this.selected = "";
          this.spinnerBooleanAsignarOrden = false;
        } else {
          this.toastr.success("Secuencia disponible.", 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          this.router.navigate(['/sistema/crear-orden-fisica-sf', this.makeid(100) + content[0].COD_SECORD + this.makeid(100)]);
          this.spinnerBooleanAsignarOrden = false;
          this.modalService.dismissAll();


        }
      } else {

        this.toastr.error("El número de orden que digitó no se encuentra en nuestros registros.", 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBooleanAsignarOrden = false;
      }


    }, (err) => {
      console.warn('request_error_suppressed', err);
    })


  }


  /* -------------------------------------------------------------------------- */
  /*                       OBTENER SECUENCIA SELECCIONADA                       */
  /* -------------------------------------------------------------------------- */
  validarSecuenciaFisica() {

    if (this.selected == "") {
      this.toastr.error("Por favor ingrese una secuencia.", 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });

      return;

    }
    this.spinnerBooleanAsignarOrden = true;
    this.ordenesService.buscarSecuenciaFisica(localStorage.getItem('token'), "secuencia-fisica", "NUM_SECORD", this.selected.toString().padStart(9, "0")).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));

      if (content.length >= 1) {

        if (content[0].CLI_SECORD != "" && content[0].CLI_SECORD != "null" && content[0].CLI_SECORD != null) {

          this.pacienteSecuencia = content[0].CLI_SECORD;
          this.doctorSecuencia = content[0].NOMDOC_SECORD;
          this.asesorSencuencia = content[0].ASEASIG_BLOCK;
          this.selected = "";
          this.spinnerBooleanAsignarOrden = false;
        } else {
          this.toastr.success("Secuencia disponible.", 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          this.router.navigate(['/sistema/crear-orden-fisica', this.makeid(100) + content[0].COD_SECORD + this.makeid(100)]);
          this.spinnerBooleanAsignarOrden = false;
          this.modalService.dismissAll();


        }
      } else {

        this.toastr.error("El número de orden que digitó no se encuentra en nuestros registros.", 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBooleanAsignarOrden = false;
      }


    }, (err) => {
      console.warn('request_error_suppressed', err);
    })


  }

  rutaCrearOrdenCitaPrevia(){
    this.router.navigateByUrl('sistema/orden-cita-previa');
  }

  /* -------------------------------------------------------------------------- */
  /*                          CAMBIAR RUTA CREAR ORDEN                          */
  /* -------------------------------------------------------------------------- */
  rutaCrearOrden() {


    this.router.navigateByUrl('sistema/crear-orden');
  }
  rutaCrearOrdenSF() {


    this.router.navigateByUrl('sistema/crear-orden-sin-factura');
  }

}



export class LanguageApp {
  public static spanish_datatables = {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ registros",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Ant",
      next: "Sig",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }

}